import request from '@/utils/request'

/**
 * 获取当前用户的动态路由配置
 * @param {Object} params - 查询参数
 * @param {number} params.sysId - 系统ID
 * @param {string} params.sysKey - 系统标识
 */
export function getUserRoutes(params = {}) {
  console.log('API: 获取用户路由配置', params)
  return request({
    url: '/system/auth/routes/user',
    method: 'get',
    params
  }).then(response => {
    console.log('API: 用户路由配置响应', response)
    return response
  }).catch(error => {
    console.error('API: 获取用户路由配置失败', error)
    // 返回空数据以避免系统崩溃
    return { data: [] }
  })
}

/**
 * 获取指定用户的路由配置（管理员功能）
 * @param {number} userId - 用户ID
 * @param {Object} params - 查询参数
 */
export function getUserRoutesById(userId, params = {}) {
  return request({
    url: `/system/auth/routes/user/${userId}`,
    method: 'get',
    params
  })
}

/**
 * 获取系统所有路由配置
 * @param {number} sysId - 系统ID
 */
export function getAllRoutes(sysId) {
  return request({
    url: '/system/auth/routes/all',
    method: 'get',
    params: { sysId }
  })
}

/**
 * 根据角色获取路由配置
 * @param {Array} roleIds - 角色ID列表
 * @param {number} sysId - 系统ID
 */
export function getRoutesByRoles(roleIds, sysId) {
  return request({
    url: '/system/auth/routes/roles',
    method: 'post',
    data: roleIds,
    params: { sysId }
  })
}

/**
 * 验证路由权限
 * @param {string} routePath - 路由路径
 */
export function checkRoutePermission(routePath) {
  return request({
    url: '/system/auth/routes/permission/check',
    method: 'get',
    params: { routePath }
  })
}

/**
 * 获取用户权限列表
 */
export function getUserPermissions() {
  console.log('API: 获取用户权限列表')
  return request({
    url: '/system/auth/routes/permissions',
    method: 'get'
  }).then(response => {
    console.log('API: 用户权限列表响应', response)
    return response
  }).catch(error => {
    console.error('API: 获取用户权限列表失败', error)
    // 返回空权限列表以避免系统崩溃
    return { data: [] }
  })
}

/**
 * 刷新路由缓存
 * @param {number} userId - 用户ID（可选）
 */
export function refreshRouteCache(userId) {
  return request({
    url: '/system/auth/routes/cache/refresh',
    method: 'post',
    params: userId ? { userId } : {}
  })
}

/**
 * 获取路由树结构
 * @param {string} sysKey - 系统标识，默认为'oa'
 */
export function getRouteTree(sysKey = 'oa') {
  return request({
    url: '/system/auth/routes/tree',
    method: 'get',
    params: { sysKey }
  })
}

/**
 * 获取OA系统路由
 */
export function getOaRoutes() {
  return getUserRoutes({ sysKey: 'oa' })
}

/**
 * 获取实验室系统路由
 */
export function getLabRoutes() {
  return getUserRoutes({ sysKey: 'lab' })
}

/**
 * 获取基础系统路由
 */
export function getBaseRoutes() {
  return getUserRoutes({ sysKey: 'base' })
}
export function getDataRoutes() {
  return getUserRoutes({ sysKey: 'data' })
}

export default {
  getUserRoutes,
  getUserRoutesById,
  getAllRoutes,
  getRoutesByRoles,
  checkRoutePermission,
  getUserPermissions,
  refreshRouteCache,
  getRouteTree,
  getOaRoutes,
  getLabRoutes,
  getBaseRoutes,
  getDataRoutes
}
